export default "__VITE_ASSET__BhaHXGl___"